import { render } from "./AppointmentCard.vue?vue&type=template&id=4cf14fd6&scoped=true"
import script from "./AppointmentCard.vue?vue&type=script&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&lang=js"

import "./AppointmentCard.vue?vue&type=style&index=0&id=4cf14fd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf14fd6"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';import Ripple from 'quasar/src/directives/Ripple.js';
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QAvatar,QImg,QIcon,QSpace,QBtn,QMenu,QList,QItem,QItemSection,QSpinnerDots});qInstall(script, 'directives', {Ripple,ClosePopup});
